import { Observable } from "rxjs";
import { post, get } from "@utils/axios";
import sessionService from "./session.service";
import { ASC, DESC } from "@utils/constants";
class HighCostPatientService {
  /***************** Initial Load APIs *********************** */

  private pageName: string = 'High Cost Report';

  getColumnsList() : Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=${this.pageName}`);
  }

  getTableData({topVal = true, limit = 5 , page = 1 , expense = "Part A" , sortBy = "" , sortType = "" , searchOn={}} : any) : Observable<any> {
    const body = {
      "expenseType" : expense,
      "top10" : topVal,
      ...(Object.keys(searchOn).length > 0 && {searchOn : searchOn})
  }
  let param = (`pageName=${this.pageName}&page=${page-1}&limit=${limit}` + ((sortBy && sortType && [ASC , DESC].includes(sortType)) ? `&sortBy=${sortBy}&sortType=${sortType}` : ''));
    return post(`${sessionService.getClient()?.appServiceUrl}/report/high-cost-patients/fetch-patients?${param}` , body);
  }

  getRefreshDate() : Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/common/recent-refresh-date`);
  }
  
  getHighCostPatientsNotes(payLoad: any): Observable<any> {
    const body = {
      ...payLoad
    }
    return post(`${sessionService.getClient()?.appServiceUrl}/report/high-cost-patients/note/fetch`, body);
  }

  createNote(body: any) {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/high-cost-patients/note/save`, body);
  }

  getBuild({timePeriod ,region , office , insurance} : {timePeriod ?: string , region ?: string , office ?: string , insurance ?: string}) {
    const body = {
      timePeriod : timePeriod,
      region : region,
      office : office,
      insurance : insurance
    }

    return post(`${sessionService.getClient()?.appServiceUrl}/report/high-cost-patients/build`, body);
  }

  dropTable() {
    return get(`${sessionService.getClient()?.appServiceUrl}/report/high-cost-patients/delete-table`);
  }
  
}

export default new HighCostPatientService();
